import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class GiosgChatResource extends BaseCamelCasedResource {
    pk() {
        return "GiosgConfig";
    }
}
GiosgChatResource.urlRoot = legacyApiResourceUrl("GiosgChat");
export { GiosgChatResource };
//# sourceMappingURL=GiosgChatResource.js.map